import axios from 'axios';
import { message, notification } from 'antd';

// Configure global Axios instance
axios.defaults.baseURL = window.location.origin;

// add request interceptor
axios.interceptors.request.use(
    (config) => {
        config.headers['Time-zone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {

        if ((
            error.response &&
            error.response.status === 401 &&
            !error.response.data.success &&
            error.response.data.redirect_to_login_page === true
        ) || (error.response &&
            error.response.status === 401 &&
            error.response.data.type === "application/json")) {
            localStorage.removeItem("user_info");
            message.destroy();
            notification.destroy();
            message.info(error.response.data.message || "Session expired, please login again!", 3)
            setTimeout(() => {
                window.location.href = "#/login";
            }, 3000)
        }
        return Promise.reject(error);
    }
);

export default axios; // Use this for explicit imports if needed



// WEBPACK FOOTER //
// ./src/api.js